import {
  AppBar,
  Toolbar,
  Button,
  Box,
  IconButton,
  Tabs,
  Tab,
} from '@mui/material';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import { navigationMap } from 'components/Route/navigationMap';
import { useRemoveAuth } from 'hooks/useRemoveAuth';
import { useAppSelector, useAppDispatch } from 'store/hook';
import { updateCustomerTheme } from 'store/auth.slice';
import { SVG } from 'components/Asset/SVG';
import { useEffect, useState } from 'react';

export const TopBar = () => {
  const { execRemoveAuth } = useRemoveAuth();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const currentTheme = useAppSelector(
    (state) => state.authReducer.customer.theme
  );
  const location = useLocation();

  // define top-level tabs
  const mainTabs = [
    {
      path: navigationMap.glencore.path,
      label: navigationMap.glencore.displayName,
    },
    {
      path: navigationMap.glencoreDistanceAnalysis.path,
      label: navigationMap.glencoreDistanceAnalysis.displayName,
      disabled: true,
    },
    // {
    //   path: navigationMap.fleetOverview.fleetSummary.path,
    //   label: navigationMap.fleetOverview.fleetSummary.displayName,
    // },
    // {
    //   path: navigationMap.fleetOverview.engineHoursSummary.path,
    //   label: navigationMap.fleetOverview.engineHoursSummary.displayName,
    // },
    // {
    //   path: navigationMap.fleetOverview.dtcSummary.path,
    //   label: navigationMap.fleetOverview.dtcSummary.displayName,
    // },
  ];
  const [currentTab, setCurrentTab] = useState(
    mainTabs.find((tab) => tab.path === location.pathname)?.path ??
      mainTabs[0].path
  );

  useEffect(() => {
    setCurrentTab(
      mainTabs.find((tab) => tab.path === location.pathname)?.path ??
        mainTabs[0].path
    );
  }, [location]);

  const handleLogout = () => {
    sessionStorage.removeItem('assetSelectedTags');
    localStorage.clear();
    execRemoveAuth();
    navigate('/login');
  };

  const handleThemeToggle = () => {
    dispatch(
      updateCustomerTheme({
        theme: currentTheme === 'dark' ? 'light' : 'dark',
      })
    );
  };

  return (
    <AppBar
      sx={{
        backgroundColor: '#092b63',
        color: '#fff',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        borderBottom: '1px solid #E0E0E0',
        position: 'sticky',
        top: 0,
      }}
    >
      <Toolbar>
        <SVG
          name="sidebarLogoMain"
          style={{ width: '100px', height: '40px', marginRight: 16 }}
        />
        <Tabs
          value={currentTab}
          textColor="primary"
          indicatorColor="primary"
          TabIndicatorProps={{
            style: { backgroundColor: '#4989f5', height: 4, borderRadius: 2 },
          }}
          sx={{
            '& .MuiTab-root': {
              minWidth: 120,
              color: '#fff',
              textTransform: 'none',
              padding: '0 16px',
            },
            '& .MuiTab-root:hover': {
              backgroundColor: '#F3F8FE',
              color: '#4989f5',
            },
            '& .Mui-selected': {
              fontWeight: 'bold',
              color: '#4989f5',
              backgroundColor: '#E3F2FD',
            },
          }}
        >
          {mainTabs.map((tab) => (
            <Tab
              disabled={tab.disabled}
              key={tab.path}
              label={tab.label}
              value={tab.path}
              component={NavLink}
              to={!tab.disabled ? tab.path : ''}
              sx={{
                '&.active': {
                  opacity: 1,
                  fontWeight: 'bold',
                },
                '&.Mui-disabled': {
                  color: '#fafafa',
                  opacity: 0.5,
                  fontWeight: 'normal',
                  backgroundColor: '#888',
                },
              }}
            />
          ))}
        </Tabs>
        <Box sx={{ flexGrow: 1 }} />
        <IconButton
          color="inherit"
          onClick={handleThemeToggle}
          aria-label="toggle theme"
        >
          {currentTheme === 'dark' ? (
            <LightModeIcon data-testid="LightModeIcon" />
          ) : (
            <DarkModeIcon data-testid="DarkModeIcon" />
          )}
        </IconButton>
        <Button sx={{ color: '#fff' }} onClick={handleLogout}>
          Logout
        </Button>
      </Toolbar>
    </AppBar>
  );
};
